import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { ConfirmationDialogData } from '../../../models/confirmation-dialog-data.dto';
import { DefectSearchParams } from '../../../models/inspection';
import { InspectionCrudService } from '../../../services/api/inspection-crud/inspection-crud.service';
import { InspectionService } from '../../../services/api/inspection/inspection.service';
import { CubeService, MessageType } from '../../../services/cube/cube.service';
import { MigrationService } from '../../../services/migration/migration.service';
import { LoaderService } from '../../../services/loader/loader.service';
import {
  IdbService,
  WhereConditions,
} from '../../../services/storage/idb.service';
import {
  StorageService,
  STORAGE_KEYS,
} from '../../../services/storage/storage.service';
import { TemplateLoaderService } from '../../../services/template-loader/template-loader.service';
import { UserService } from '../../../services/user/user.service';
import { BridgeCombinedDefects } from '../../../shared/configs/bridge-combined-defects.config';
import { ComponentMaterialMappingObj } from '../../../shared/configs/bridge-component-material-mapping.config';
import { BridgeConstants } from '../../../shared/configs/bridge-constants.config';
import { BridgeTemplateVersion } from '../../../shared/configs/bridge-template-version.config';
import { CdAState } from '../../../shared/configs/cda-state.config';
import { CdAStatus } from '../../../shared/configs/cda-status.config';
import { DirezioneConfig } from '../../../shared/configs/direzione.config';
import { InspectionStatus } from '../../../shared/configs/inspection-status.config';
import { InspectionType } from '../../../shared/configs/inspection-type.config';
import { StructureConstants } from '../../../shared/configs/structure-constants.config';
import { StructureType } from '../../../shared/configs/structure-type.config';
import { UserRole } from '../../../shared/configs/user-role.config';

import { FormlyFormOptions } from '@ngx-formly/core';
import { Subscription } from 'dexie';
import moment from 'moment';
import { from, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cube-view-bridge-inspection',
  templateUrl: './view-bridge-inspection.component.html',
  styleUrls: ['./view-bridge-inspection.component.scss'],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
  ],
  standalone: false,
})
export class ViewBridgeInspectionComponent implements OnInit, OnDestroy {
  bridgeConstants: typeof BridgeConstants = BridgeConstants;
  campateCount: number = 0;
  campateNoList: any[] = [];
  devMode = environment.devMode; // TEMP: For development
  direzioneList: Record<string, string>[] = [];
  fields: any[] = [];
  form: FormGroup = new FormGroup({});
  isOnline: boolean = true;
  isShortcutView: boolean = false;
  l0BackupData: any = {};
  l1BackupData: any = {};
  l1InitBackupData: any = {};
  l2UpdateStatus: boolean = false;
  l3UpdateStatus: boolean = false;
  level2Backup: any = {};
  level2CampataBackup: any = {};
  level2CampateListBackup: any = [];
  levelsList: string[];
  model: any;
  options: FormlyFormOptions;
  riskIndex: number; // TODO: reuse l2UpdateIndex
  token: string;

  private allElementoList: any[];
  private appImportedInspectionId: string = '';
  private destroy$: Subject<void> = new Subject<void>();
  private idbRecordId: string;
  private inspectionId: string = '';
  private inspectionType: InspectionType;
  private isDisabled: boolean = true;
  private l1UpdateIndex: number;
  private l1UpdateStatus: boolean = false;
  private l2CampataNo: number;
  private l2UpdateIndex: number; // TODO: rename
  private l3UpdateComponent: string = '';
  private l3UpdateDirezione: string = '';
  private l3UpdateElementNo: number;
  private l3UpdateIndex: number;
  private massiveImportedInspection: any;
  private plannedInspection;
  private plannedInspectionId: string = '';
  private recordId: string = '';
  private saveStatus: boolean = false;
  private templateVersion: string;
  private tenantId: string;
  private unsubscribe$: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private cubeService: CubeService,
    private idbService: IdbService,
    private inspectionCrudService: InspectionCrudService,
    private inspectionService: InspectionService,
    private loaderService: LoaderService,
    private location: Location,
    private matDialog: MatDialog,
    private router: Router,
    private storageService: StorageService,
    private templateLoaderService: TemplateLoaderService,
    private userService: UserService
  ) {
    this.inspectionId =
      this.activatedRoute.snapshot.paramMap.get('inspectionId');
    /* // INFO: Functionality not applicable in PORTAL
    this.inspectionType = +this.activatedRoute.snapshot.paramMap.get('type');
    this.templateVersion = this.activatedRoute.snapshot.paramMap.get('templateVersion'
    ) as BridgeTemplateVersion;
    this.tenantId = this.activatedRoute.snapshot.paramMap.get('tenantId');
    this.direzioneList = this.createDirezioneList(); */
    this.storageService.addToStorage(STORAGE_KEYS.savedImages, []);
    this.storageService.addToStorage(STORAGE_KEYS.deletedFiles, []);
    this.fetchDirezioneList();
    /* // INFO: Functionality not applicable in PORTAL
    this.allElementoList = this.setAllElementoList(); */
    this.levelsList = this.createLevelsList();
    this.model = this.createModel();
    this.options = this.createFormlyOptions();
  }

  ngOnInit(): void {
    this.getInspectionMediaToken().then(() => {
      this.getInspection(this.inspectionId);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addDefectImagesIndexToBeModified(defectList: any[], index: number): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  addRepeatSectionImagesIndexToBeModified(
    list: any[],
    index: number,
    key: string
  ): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  /**
   * Clears the empty model.
   * If the user navigates away from the page before or without saving,
   * it deletes all files in indexed db under this inspection.
   */
  /* // INFO: Functionality not applicable in PORTAL
  @HostListener('window:beforeunload') */
  clearEmptyModel(): void {
    // INFO: Functionality not applicable in PORTAL
  }

  /**
   * Copies the risk sheets data for a given sheet name.
   *
   * @param sheetName - The name of the sheet to be copied.
   */
  copyRiskSheets(sheetName: string): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  /**
   * Adds defect files uploaded to the database or IndexedDB to the list of deleted files in local storage. Called when campata / defect template is deleted.
   *
   * @param urlList - An array of tuples containing the file URL and its corresponding key.
   * @returns void
   */
  deleteUploadedDefectFiles(urlList: string[]): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  /**
   * Adds non-defect files uploaded to the database or IndexedDB to the deleted files list in local storage.
   *
   * @param fileNames - The name or names of the files to be deleted.
   */
  deleteUploadedFiles(fileNames: string | string[]): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  duplicateDefect(
    index: number,
    list: any[],
    type: string,
    listName: string
  ): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  async getCampataAttentionClass(): Promise<void> {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  getCdaClassName(value: any): string | null {
    // INFO: Used in template

    if (typeof value === 'boolean' || typeof value === 'number') return null;

    const cdAStatusList = this.getCdAStatusList();

    return cdAStatusList.some(
      (status) => status?.toLowerCase() === value?.toLowerCase()
    )
      ? value.replace(/\s/g, '').toLowerCase()
      : null;
  }

  getConfirmation(dialogData?: ConfirmationDialogData): any {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  getDeepCopy(item: any): any {
    // INFO: Used in template
    return this.cubeService.getDeepCopy(item);
  }

  getDefectsList(
    level: string,
    component: string,
    material: string = ''
  ): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  getElementiAccessoriDefects(): void {
    // INFO: Used in template
    this.getDefectsList(
      BridgeConstants.elementiAccessori,
      BridgeConstants.elementiAccessori,
      ''
    );
  }

  getFraneOrIdraulicaRiskSheetDefaultValues(sheetName: string): any {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  getItemFromListByValue(list, value): any {
    // INFO: Used in template
    return list.find((item) => item.value === value);
  }

  getLevel1TipologiaElementiStructures(): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  hasValue(value: any): boolean {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
    return false;
  }

  isCampataPresentInL1(campataNo: number): boolean {
    // INFO: Used in template
    const l1CampateList =
      this.model[BridgeConstants.levels.l0].opereparzialilist?.[0]
        ?.modelstructure?.campatelist ?? [];

    const isCampataPresentInL1 = l1CampateList.some(
      (l1Campata) => l1Campata[BridgeConstants.partNo] === campataNo
    );

    return isCampataPresentInL1;
  }

  isFieldDisabled(
    rolesList: UserRole[],
    isDisabled: boolean,
    isNotAllowed: boolean = false
  ): boolean {
    // INFO: Used in template
    if (isDisabled) return true;

    const isUserAllowedByRole = rolesList.length
      ? this.userService.isUserAllowedByRole(rolesList)
      : true;

    return isNotAllowed ? isUserAllowedByRole : !isUserAllowedByRole;
  }

  isLivelloDiDifettositaValueChanged(value: string): boolean {
    // INFO: Used in template
    return ['ALTO', 'MEDIO-ALTO', 'MEDIO', 'MEDIO-BASSO', 'BASSO'].includes(
      value
    );
  }

  isSaveButtonDisabled(): any {
    // INFO: Functionality not applicable in PORTAL
  }

  migrateDataToChildLevel(
    index: number,
    destinationLevel: string,
    sourceList,
    elementNo: string
  ): void {
    // INFO: Used in template
    switch (destinationLevel) {
      case BridgeConstants.levels.l1:
        this.campateCount = sourceList[0].modelstructure.campatelist.length;
        /* // INFO: Functionality not applicable in PORTAL
        this.saveDeletedFilesToCurrentLevel(
          this.model[BridgeConstants.levels.l0]
        );
        this.l0BackupData = this.getDeepCopy(
          this.model[BridgeConstants.levels.l0]
        ); */
        this.l1UpdateStatus = true;
        this.l1UpdateIndex = index;

        break;

      case BridgeConstants.levels.l2:
        /* // INFO: Functionality not applicable in PORTAL
        this.saveDeletedFilesToCurrentLevel(
          this.model[BridgeConstants.levels.l1]
        );
        this.l1BackupData = this.getDeepCopy(
          this.model[BridgeConstants.levels.l1]
        ); */
        this.l2UpdateStatus = true;
        this.l2UpdateIndex = index;
        this.l2CampataNo = sourceList[index][BridgeConstants.partNo];

        break;

      case BridgeConstants.levels.level2:
        /* // INFO: Functionality not applicable in PORTAL
        this.level2Backup = this.getDeepCopy(
          this.model[BridgeConstants.levels.level2]
        ); */

        break;

      case BridgeConstants.levels.level2Campata:
        /* // INFO: Functionality not applicable in PORTAL
        this.level2CampateListBackup = this.getDeepCopy(sourceList); */
        this.riskIndex = index;
        /* // INFO: Functionality not applicable in PORTAL
        this.level2CampataBackup = this.getDeepCopy(sourceList[index]); */

        break;

      case BridgeConstants.levels.spalle: // Defects Template - Spalle
      case BridgeConstants.levels.pile: // Defects Template - Pile
      case BridgeConstants.levels.archi: // Defects Template - Archi
      case BridgeConstants.levels.impalcati: // Defects Template - Impalcati
      case BridgeConstants.levels.giunti: // Defects Template - Giunti
      case BridgeConstants.levels.apparecchiSismici: // Defects Template - Apparecchi Sismici
      case BridgeConstants.levels.fileDiAppoggi: // Defects Template - File di Appoggi
        this.l3UpdateStatus = true;
        this.l3UpdateIndex = index;
        this.inspectionService.setDefectRowIndex$(index);
        this.l3UpdateComponent = sourceList[index].modelstructure.component;
        this.l3UpdateDirezione = sourceList[index].modelstructure.direzione;
        this.l3UpdateElementNo = sourceList[index].modelstructure[elementNo];
        this.model[destinationLevel].component =
          sourceList[index].modelstructure.component;
        this.model[destinationLevel].materiale =
          sourceList[index].modelstructure.materiale;

        /* // Functionality now handled by syncSharedModelDataForList(). The following code can be removed at a later stage.
        // Setting Codice IOP for defect levels
        for (const source of sourceList) {
          source.modelstructure['Scheda Ispezione Ponti di Livello 1'][
            'Codice IOP'
          ] = this.model[BridgeConstants.levels.l0]['Codice IOP'];
        } */
        /* // INFO: Functionality not applicable in PORTAL
         this.saveDeletedFilesToCurrentLevel(
          this.model[BridgeConstants.levels.l2]
        ); */

        break;
    }

    this.model[destinationLevel] ??= {};
    this.form = new FormGroup({});
    this.model[destinationLevel] = this.getDeepCopy(
      sourceList[index].modelstructure
    );
    this.options.formState[destinationLevel] = false;
  }

  onChangeElementiAccessoriCasoOption(): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  onClickBack(): void {
    if (this.isShortcutView) {
      // Disabling shortcut view
      this.isShortcutView = false;

      // Navigating to Level 2 // TODO - try to navigate back to the correct tab
      // this.model.activeLevel = BridgeConstants.levels.level2Campata;
      this.switchActiveLevel(BridgeConstants.levels.level2Campata);
      /* // INFO: Functionality not applicable in PORTAL
      this.options.formState.l1Descrizione = true;
      this.options.formState.l1Frane = false;
      

      // Restoring backup data to both the levels
      this.model[BridgeConstants.levels.l0] = this.l0BackupData;
      this.model[BridgeConstants.levels.level2Campata] =
        this.level2CampataBackup;

      this.refreshFields(); */

      return;
    }

    /* // INFO: Functionality not applicable in PORTAL
    this.cubeService
      .confirm({
        message:
          (this.model.activeLevel === BridgeConstants.levels.l0
            ? 'Do you want to go back to home page? '
            : '') + 'If you go back any unsaved progress will be lost.',
      })
      .pipe(
        filter((isConfirmed) => isConfirmed),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.goBack();
      }); */
    this.goBack();
  }

  onClickGotoLevel(level: string, level1SubSection?: string): void {
    // INFO: Used in template
    // Setting shortcut view
    this.isShortcutView = true;

    /* // INFO: Functionality not applicable in PORTAL
    this.l0BackupData = this.getDeepCopy(this.model[BridgeConstants.levels.l0]);
    this.level2CampataBackup = this.getDeepCopy(
      this.model[BridgeConstants.levels.level2Campata]
    ); */

    // Navigating to the selected level
    switch (level) {
      case BridgeConstants.levels.l0:
        // this.model.activeLevel = BridgeConstants.levels.l0;
        this.switchActiveLevel(BridgeConstants.levels.l0);

        break;

      case BridgeConstants.levels.l1:
        this.model[BridgeConstants.levels.l1] = this.getDeepCopy(
          this.model[BridgeConstants.levels.l0].opereparzialilist[0]
            .modelstructure
        );

        // Setting the correct subsection
        this.options.formState.l1Descrizione =
          level1SubSection === 'descrizione' ? true : false;
        this.options.formState.l1Frane =
          level1SubSection === 'descrizione' ? false : true;
        // this.model.activeLevel = BridgeConstants.levels.l1;
        this.switchActiveLevel(BridgeConstants.levels.l1);

        break;
    }

    this.refreshFields();
  }

  async onClickSave(): Promise<void> {
    // INFO: Functionality not applicable in PORTAL
  }

  openDuplicateCampataDialog(selectedIndex: number): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  openNewDefectDialog(level: string, type: string, rowIndex = null): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  refreshFields(): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  async resetAllCampataAttentionClass(): Promise<void> {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  async resetIndividualCampataAttentionClass(campata: any): Promise<void> {
    // INFO: Functionality not applicable in PORTAL
  }

  resetParentForm(fieldForm: FormGroup): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  saveModelToIndexedDbForPlannedInspection(): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  // Moving saved images of parent to corresponding parent in model from storage
  setImages(level: string): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  setIsLevel2DataChanged(): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  setMaterials(component, field, updateStatus): void {
    // INFO: Used in template
    for (let j = 0; j < field.parent.fieldGroup.length; j++) {
      if (field.parent.fieldGroup[j].key !== 'materiale') continue;

      if (!updateStatus) field.parent.fieldGroup[j].formControl.setValue(null);

      field.parent.fieldGroup[j].props.options = component.materials;

      return;
    }
  }

  async setUniqueCode(level, elementNo, defect): Promise<void> {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  switchActiveLevel(level: string): void {
    // INFO: Used in template
    this.form.get('activeLevel').setValue(level);
    this.model = { ...this.model }; // TODO: Check if this is needed; if yes then add to APP as well.
  }

  syncRepeatSections(
    pathsKey: string,
    changedPathNo: string,
    removedIndex?: number
  ): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  /* // INFO: Tecnico syncing to defect level
  syncRepeatSectionsFromDefectLevels(
    propPaths: any[],
    updatedList: any[]
  ): void {
    // INFO: Functionality not applicable in PORTAL
  } */

  syncSharedModelData(
    pathsKey: string,
    updatedValue: any,
    changedIndex?: number
  ): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  syncSharedModelDataForList(pathsKey: string, updatedValue: any): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  updateFieldValue(fieldPath: string[], value: any): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL?
  }

  updateUniqueCode(
    deletedObject,
    defectList: string,
    defect,
    index: number
  ): void {
    // INFO: Used in template
    // INFO: Functionality not applicable in PORTAL
  }

  private createFormlyOptions(): FormlyFormOptions {
    return {
      formState: {
        l1Descrizione: true,
        l1Frane: true,
        [BridgeConstants.levels.spalle]: true,
        [BridgeConstants.levels.pile]: true,
        [BridgeConstants.levels.archi]: true,
        [BridgeConstants.levels.impalcati]: true,
        [BridgeConstants.levels.giunti]: true,
        [BridgeConstants.levels.apparecchiSismici]: true,
        [BridgeConstants.levels.fileDiAppoggi]: true,
      },
    };
  }

  private createLevelsList(): string[] {
    const levelsList = Object.values(BridgeConstants.levels);

    return [...levelsList];
  }

  private createModel(): any {
    return {};
  }

  private fetchDirezioneList(): void {
    const direzioneConfig = DirezioneConfig;

    this.direzioneList = Object.keys(direzioneConfig).map((item) => {
      return {
        label: DirezioneConfig[item].fullName,
        value: item,
      };
    });

    this.direzioneList.push({
      label: null,
      value: null,
    });
  }

  private getCdAStatusList(): string[] {
    return [
      CdAStatus.alta,
      CdAStatus.medioAlta,
      CdAStatus.media,
      CdAStatus.medioBassa,
      CdAStatus.bassa,
    ];
  }

  private getInspection(inspectionId: string): void {
    this.inspectionService
      .getInspection(inspectionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.model.status = res.data.status;
        // this.model.templateId = res.data.templateId; // TODO can be removed?

        if (this.model.status === InspectionStatus.imported) {
          this.massiveImportedInspection = res.data;
        } else {
          this.model = res.data;
        }

        this.getTemplateByVersion(this.model.version);
      });
  }

  private getInspectionMediaToken(): Promise<void> {
    return this.inspectionService
      .getInspectionMediaToken()
      .pipe(
        map((res) => {
          this.token = res.data.token;
        }),
        takeUntil(this.destroy$)
      )
      .toPromise();
  }

  private async getTemplateByVersion(
    templateVersion: BridgeTemplateVersion
  ): Promise<void> {
    const template = await this.templateLoaderService.loadBridgeTemplate(
      templateVersion,
      {
        component: this,
        isDisabled: this.isDisabled,
      }
    );
    this.setTemplate(template);
  }

  private goBack(): void {
    switch (this.model.activeLevel) {
      case BridgeConstants.levels.l0: // Livello 0
        this.location.back();

        break;

      case BridgeConstants.levels.l1: // Level 1
        this.l1UpdateStatus = false;
        delete this.l1UpdateIndex;
        // this.model.activeLevel = BridgeConstants.levels.l0;
        this.switchActiveLevel(BridgeConstants.levels.l0);
        /* // INFO: Functionality not applicable in PORTAL
        this.clearDeletedFilesFromCurrentLevelAndStorage(
          this.model[BridgeConstants.levels.l1]
          );
        this.model[BridgeConstants.levels.l0] = this.l0BackupData;
        this.model[BridgeConstants.levels.l1] = this.l1InitBackupData;
        this.options.formState[BridgeConstants.levels.l1] = true; */
        this.options.formState.l1Descrizione = true;
        /* // INFO: Functionality not applicable in PORTAL
        this.refreshFields(); */

        break;

      case BridgeConstants.levels.l2: // Level 2 (l2)
        this.l2UpdateStatus = false;
        delete this.l2UpdateIndex;
        delete this.l2CampataNo;
        /* // INFO: Functionality not applicable in PORTAL
        this.clearDeletedFilesFromCurrentLevelAndStorage(
          this.model[BridgeConstants.levels.l2]
        );
        this.model[BridgeConstants.levels.l1] = this.l1BackupData;
        this.resetFields();
        this.options.formState[BridgeConstants.levels.l2] = true; = true; */
        this.options.formState.l1Descrizione = true;
        this.options.formState.l1Frane = false;
        // this.model.activeLevel = BridgeConstants.levels.l1;
        this.switchActiveLevel(BridgeConstants.levels.l1);
        /* // INFO: Functionality not applicable in PORTAL
        this.refreshFields(); */

        break;

      case BridgeConstants.levels.spalle: // Defects Template - Spalle
      case BridgeConstants.levels.pile: // Defects Template - Pile
      case BridgeConstants.levels.archi: // Defects Template - Archi
      case BridgeConstants.levels.impalcati: // Defects Template - Impalcati
      case BridgeConstants.levels.giunti: // Defects Template - Giunti
      case BridgeConstants.levels.apparecchiSismici: // Defects Template - Apparecchi Sismici
      case BridgeConstants.levels.fileDiAppoggi: // Defects Template - File di Appoggi
        this.l3UpdateStatus = false;
        delete this.l3UpdateIndex;
        this.l3UpdateComponent = '';
        this.l3UpdateDirezione = '';
        delete this.l3UpdateElementNo;
        /* // INFO: Functionality not applicable in PORTAL
        this.clearDeletedFilesFromCurrentLevelAndStorage(
          this.model[this.model.activeLevel]
        );
        this.model[this.model.activeLevel][`${this.model.activeLevel} No`] = '';
        if (this.model[this.model.activeLevel].component)
          delete this.model[this.model.activeLevel].component;
        if (this.model[this.model.activeLevel].direzione)
          delete this.model[this.model.activeLevel].direzione;
        if (this.model[this.model.activeLevel].materiale)
          delete this.model[this.model.activeLevel].materiale;
    
        this.options.formState[this.model.activeLevel] = true; */
        // this.model.activeLevel = BridgeConstants.levels.l2;
        this.switchActiveLevel(BridgeConstants.levels.l2);
        /* // INFO: Functionality not applicable in PORTAL
        this.refreshFields(); */

        break;

      case BridgeConstants.levels.level2: // Level 2
        /* // INFO: Functionality not applicable in PORTAL
        this.clearDeletedFilesFromCurrentLevelAndStorage(
        this.model[BridgeConstants.levels.level2]
        );
        this.model[BridgeConstants.levels.level2] = this.level2Backup; */
        // this.model.activeLevel = BridgeConstants.levels.l0;
        this.switchActiveLevel(BridgeConstants.levels.l0);
        /* // INFO: Functionality not applicable in PORTAL
        this.isLevel2DataChanged = false;
        this.refreshFields(); */

        break;

      case BridgeConstants.levels.level2Campata: // Level 2 Campata
        /* // INFO: Functionality not applicable in PORTAL
        this.clearDeletedFilesFromCurrentLevelAndStorage(
        this.model[BridgeConstants.levels.level2Campata]
        );
        this.model[BridgeConstants.levels.level2].campateCdaStatus.campateList =
        this.level2CampateListBackup; */
        // this.model.activeLevel = BridgeConstants.levels.level2;
        this.switchActiveLevel(BridgeConstants.levels.level2);
        /* // INFO: Functionality not applicable in PORTAL
        this.refreshFields(); */

        break;
    }
  }

  private setTemplate(template: any): void {
    // Getting dynamic model structure from template
    const dynamicModelStructure = template.shift();
    if (this.model.status === InspectionStatus.imported) {
      // If massiveImportedInspection, adding the dynamic model structure into the model
      this.model = {
        ...this.model,
        ...dynamicModelStructure.model,
      };
    }

    this.fields = template;
    this.updateModelForNewInspectionVariants();
  }

  private updateModelForNewInspectionVariants(): void {
    if (this.model.status !== InspectionStatus.imported) return;

    // Looping through each key in importStructure
    Object.values(this.model.importStructure).forEach((importPaths: any[]) => {
      // Fetching the value from the massiveImportedInspection
      const value = this.cubeService.getPropByPathList(
        this.massiveImportedInspection,
        importPaths[0]
      );

      // Looping through each path of this key
      importPaths.forEach((importPath) => {
        // Looping through the parts in this path
        importPath.reduce((modelObj, pathKey, i) => {
          if (i === importPath.length - 1) {
            // If last part in path setting the value to the model
            modelObj[pathKey] = value;
          } else {
            // If not last part and path is empty, then setting empty object as part
            modelObj[pathKey] ??= {};
          }

          // Returning the item from model
          return modelObj[pathKey];
        }, this.model);
      });
    });
  }
}
